import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  success: false,
};

const mailOnaySlice = createSlice({
  name: "mailOnay",
  initialState,
  reducers: {
    mailOnayStart: (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    mailOnaySuccess: (state) => {
      state.loading = false;
      state.error = null;
      state.success = true;
    },
    mailOnayError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    mailOnayReset: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const { mailOnayStart, mailOnaySuccess, mailOnayError, mailOnayReset } =
  mailOnaySlice.actions;

export default mailOnaySlice.reducer;
